import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'cq-file-preview',
  templateUrl: './cq-file-preview.component.html',
  styleUrls: ['./cq-file-preview.component.scss']
})
export class CqFilePreviewComponent implements OnInit {

  @Input() formCtrl: FormControl
  
  constructor() { }

  ngOnInit(): void {

  }

  fileExtension(){
    const file : File = this.formCtrl?.value 
    if( !file ) return null 
    const split = file.name.split('.')
    if( !split || split.length <= 1 ) return null 

    return split[ split.length - 1 ].toLowerCase()

  }

  isManaged( ){
    const extesion = this.fileExtension()
    if ( ! extesion ) return false  
    return  [ 
      'png' 
    , 'jpg'
    , 'jpeg'
    , 'gif'
    ].find( ext => ext == extesion ) ? true : false
  }
}
